export default "__VITE_ASSET__7b3a4877__"